export default "__VITE_ASSET__BRMVlBNl__"